import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://wpyzyyuuloojbdpqdmde.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6IndweXp5eXV1bG9vamJkcHFkbWRlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDg4OTU1OTUsImV4cCI6MjA2NDQ3MTU5NX0.Nk40rIovtwfISPeHXh8bF7_2Bs8S963tTGbuiMyq7Gk';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
